import React from 'react'

export const ActivityLogIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.5 1.5h7a1 1 0 011 1v12a1 1 0 01-1 1h-7a1 1 0 01-1-1v-12a1 1 0 011-1z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
    <path
      d="M5.5 4.5h5M5.5 7.5h5M5.5 10.5h4M5.5 13.5h3"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </svg>
)
